import {Route,Switch,BrowserRouter } from "react-router-dom";

import PushNotification from "components/Doobi/PushNotification";
import DoobiHeader from "components/Headers/DoobiHeader";
import PushNotificationsTable from "components/Doobi/PushNotifications";

const PushNotificationRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="PushNotification" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/send`} component={PushNotification}/>
      <Route path={`${match.path}/`} component={PushNotificationsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default PushNotificationRoute;
